import React from 'react';
import cx from 'clsx';

import './style.module.scss';

type Option = {
  value: string;
  text: string;
};

type SelectProps<T extends Option[]> = React.ComponentProps<'input'> & {
  options: T;
  onValueChange?: (
    value: T[number]['value'],
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => void;
  defaultValue?: T[number]['value'];
};

export const Select = <T extends Option[]>({
  value,
  className,
  options,
  onValueChange: onValueChange,
}: SelectProps<T>) => {
  return (
    <select
      onChange={(e) => {
        onValueChange?.(e.target.value, e);
      }}
      value={value}
      className={cx(
        'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-11 w-full min-w-0 rounded-md border bg-[#f7f7f7] px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        className,
      )}
    >
      {options.map(({ value, text }) => {
        return (
          <option key={value} value={value}>
            {text}
          </option>
        );
      })}
    </select>
  );
};
